import img1 from "../images/cloudEducation/img1.jpg";
import img2 from "../images/cloudEducation/img2.jpg";
import img3 from "../images/cloudEducation/img3.jpg";
import img4 from "../images/cloudEducation/img4.jpg";
import img5 from "../images/cloudEducation/img5.jpg";
import img6 from "../images/cloudEducation/img6.jpg";



import video5jpg from "../images/cloudEducation/video5.jpg";
import video5 from "../images/cloudEducation/video5.mp4";

export const imgCloudEducation = [
  {
    id: 1101,
    type: 'image',
    image: img1
  },{
    id: 1102,
    type: 'image',
    image: img2
  },{
    id: 1103,
    type: 'image',
    image: img3
  },{
    id: 1104,
    type: 'image',
    image: img4
  },{
    id: 1105,
    type: 'image',
    image: img5
  },{
    id: 1106,
    type: 'image',
    image: img6
  }
];
